export default __webpack_public_path__ + "static/paul-e117b4115a1ec9475bc666e6a7867c29.jpg";